import React from 'react'
import HeroSection from "./HeroSection";
import Breadcrumb from "./Breadcrumb";
import "./Its.css";
import { Button } from 'react-scroll';



function Its() {
  const handleDownload = () => {
    const link = document.createElement('a'); // Create a temporary link
    link.href = '/img/brochure.pdf'; // Path to your PDF file (relative to the public folder)
    link.download = 'ITMS_Brochure.pdf'; // Name of the downloaded file
    link.click(); // Simulate a click to trigger the download
  };
  return (
    <div className="aboutInfo">


    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Intelligent Transport Systems"
        backgroundImage="/img/Its.jpg"
      />

      <Breadcrumb  />

      <div className="its-container">
      <div className="row">
        <div className="col-md-6 text-center">
          <img alt="about" src="./img/bus.png" className="about-img" />
        </div>
        <div className="col-md-6">
          <h2 className="block-h1">ITMS OVERVIEW</h2>
          <p className="points-p">
  Passenger Information System 
  and Intelligent Transport Management System as the part of the supply of buses.
</p>

<ol className="points-list">
  <li>Passenger Information System (PIS) to be setup inside the buses with LED display units to display the following details.
    <ul>
      <li>Route Information at the Front, Rear, and side Displays.</li>
      <li>To display current and next bus stop information at the inner display.</li>
    </ul>
  </li>
  <li>Bus Driver Console for monitoring the live view of inside bus, Route configuration, Vehicle Health monitoring, alert messages selection by the Driver.</li>
  <li>Surveillance system inside the buses with three dome cameras and one rear view camera, along with a mobile NVR. The camera feeds need to be stored at the Mobile NVR and live broadcasted to the control center whenever needed.</li>
</ol>
        </div>
      </div>
    </div>
    <div className="its-container">
      <div className="row">
        <div className="col-md-6">
<ol className="points-list" start={4}>
  <li>Dashboard camera with two cameras (front & rear) to analyze 
  traffic violations (if any) as well as for monitoring the driver.
  </li>
  <li>Public Address System (PAS) using LED TV along with MIC at the 
  dash board</li>
  <li>Vehicle Location Tracker for monitoring the current status of 
  vehicle.</li>
  <li>Panic Button for generating alert during emergency situation.</li>
</ol>
        </div>
        <div className="col-md-6 text-center">
          <img alt="about" src="./img/bus2.png" className="about-img2" />
        </div>
      </div>
    </div>
{/* components */}
   <div className="container about">
        <div className="row">
          <div className="col-md-6 text-center">
            <img alt="about" src="./img/bus3.png" className="about-img" />
          </div>
          <div className="col-md-6">
            <h2 className="block-h1">COMPONENTS</h2>
            <ul className="points-list" >
  <li>Single Control Unit (SCU) </li>
  <li>Bus Driver Console</li>
  <li>Cameras for Surveillance</li>
  <li>Passenger Information System</li>
  <li>LED Destination Boards</li>
  <li>Vehicle Tracking System</li>
  <li>Wi-Fi for passengers</li>
  <li>Display Wiring Harness</li>
  <li>Pole Mounted Ticket Validator</li>
  <li>LED TV</li>
  <li>Music Player</li>
</ul>
          </div>
        </div> 
      </div>


      <div className="container-its">
        <div className="row">
          <div className="col-md-6">
            <h2 className="block-h1">FUNCTIONAL BLOCK DIAGRAM</h2>
          </div>
          <div className="col-md-6 text-center">
            <img alt="about" src="./img/block.png" className="block-diagram-img" />
          </div>
        </div>
      </div>

      <div className='customers'>
          <h1 className='block-h1'> OUR ITMS PRODUCTS</h1>
          <div className="scrollable-gallery">
    {/* Add customer logos */}
    <img src="/img/led.png" alt="Customer 1" className="customer-logo" />
    <img src="/img/scu.png" alt="Customer 2" className="customer-logo" />
    <img src="/img/display.png" alt="Customer 3" className="customer-logo" />
    <img src="/img/camera.png" alt="Customer 4" className="customer-logo" />
    <img src="/img/reverse-camera.png" alt="Customer 5" className="customer-logo" />
    <img src="/img/speakers.png" alt="Customer 6" className="customer-logo" />
    <img src="/img/mic.png" alt="Customer 7" className="customer-logo" />
    <img src="/img/validator.png" alt="Customer 8" className="customer-logo" />
    <img src="/img/tv.png" alt="Customer 9" className="customer-logo" />
    <img src="/img/wifi.png" alt="Customer 9" className="customer-logo" />
  </div>

  <Button className='btn' onClick={handleDownload}> Download Brochure For Product Specifiactions</Button>
  </div>
    </div>
    </div>
  )
}

export default Its